export default "__VITE_ASSET__BCK2S2gr__"